<div class="container col-sm-8 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question}}</h1>
    <div class="col-sm-12">
        <div class="d-flex  m-auto col-sm-6 col-md-6 col-xl-8">
            <div class="col-6 q-cards">
                <label class="card card-list pt-2 text-center d-inline-block pull-right" for="Lease">
                    <img src="{{lease_src}}" height="100px">
                    <div></div>
                    <label for="Lease">Lease</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
                        <input type="checkbox" class="custom-control-input mgntp10" id="Lease" value="Lease" name="rent_own"
                            [(ngModel)]="hgValue.value1" (click)="getValue($event)" />
                        <label class="custom-control-label" for="Lease"></label>
                    </div>
                </label>
            </div>
            <div class="col-6 q-cards">
                <label class="card card-list pt-2 text-center d-inline-block pull-left" for="Own">
                    <img src="{{own_src}}" height="100px">
                    <div></div>
                    <label for="Own">Own</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox shadow-none mb-2">
                        <input type="checkbox" class="custom-control-input mgntp10" id="Own" value="Own" name="rent_own"
                            [(ngModel)]="hgValue.value2" (click)="getValue($event)" />
                        <label class="custom-control-label" for="Own"></label>
                    </div>
                </label>
            </div>
        </div>
    </div>
    <p class="m-0 mt-4 text-muted tapmsg">{{questionObj.chkboxtype}}</p>
    <button *ngIf="showbutton"  class="btn next mr-2 ml-2 disabledButton mt-2 font22 text-uppercase" [ngClass]="{'combtn': isChecked}"(click)="next();">Next</button>
</div>
<div class="container mobileview px-0 mb-3" [attr.id]="questionObj._id" style="float:left; width: 100%">
        <div class="d-flex h-100 row col-sm-12 pr-0">
                <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
            <img style="width:100%;" src="assets/images/logo-charcoal.png" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto">
            <div class="arrow_box">
                    <h1 class="questionMob text-left"><span class="align-middle">{{question}}</span></h1>
            </div>
        </div>
    </div>
    <div class="row col-sm-12 m-auto">
        <div class="d-flex mt-2">
            <div class="col-6 pl-0 box-shadow-none">
                <label class="col-12 card card-list text-center d-inline-block" for="Lease" style="min-height: 126px;">
                    <img src="{{lease_src}}" width="60%">
                    <label for="Lease" class="col-12 mt-1">Lease</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                        <input type="checkbox" class="custom-control-input mgntp10" id="Lease_mob" value="Lease" name="rent_own"
                            [(ngModel)]="hgValue.value1" (click)="getValue($event)" />
                        <label class="custom-control-label" for="Lease"></label>
                    </div>
                </label>
            </div>
            <div class="col-6 pr-0 box-shadow-none">
                <label class="col-12 card card-list text-center d-inline-block" for="Own" style="min-height: 126px;">
                    <img src="{{own_src}}" width="60%" class="mt-1">
                    <label for="Own" class="col-12">Own</label>
                    <div class="custom-control custom-checkbox boxchkbox chkbox mb-2">
                        <input type="checkbox" class="custom-control-input mgntp10" id="Own_mob" value="Own" name="rent_own" [(ngModel)]="hgValue.value2"
                            (click)="getValue($event)" />
                        <label class="custom-control-label" for="Own"></label>
                    </div>
                </label>
            </div>
        </div>
        <p class="m-auto text-muted tapmsg">{{questionObj.chkboxtype}}</p>
        <div style="width:100% !important; text-align: right;">
        <div *ngIf="user_bot" class="ash_box text-right mt-2">
            <h1 class="ansMob text-right" *ngIf="lease_own == 'Lease'">I lease my space</h1>
            <h1 class="ansMob text-right" *ngIf="lease_own == 'Own'">I own my building</h1>
        </div>
        </div>
        <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
            <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
                <img style="width:100%;" src="assets/images/logo-charcoal.png" />
            </div>
            <div class="col-sm-2 col-2 px-0 my-auto">
                <div class="arrow_box">
                    <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
                </div>
            </div>
        </div>
    </div>
</div>